import i18n from "./i18n";
import { ELanguage } from "../interfaces";

const updateLanguage = (lang: ELanguage) => {
  i18n.changeLanguage(lang as string);
  window.localStorage.setItem(`lang`, lang);
};

const getCurrentLanguage = () => {
  return window.localStorage.getItem("lang");
};

export { updateLanguage, getCurrentLanguage };
